import { render, staticRenderFns } from "./integralClassify.vue?vue&type=template&id=3a069454"
import script from "./integralClassify.vue?vue&type=script&lang=js"
export * from "./integralClassify.vue?vue&type=script&lang=js"
import style0 from "./integralClassify.vue?vue&type=style&index=0&id=3a069454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports